import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideMessaging, Messaging } from '@angular/fire/messaging';
import { FIREBASE_CONFIG, FIREBASE_CONFIG_PROVIDER } from './firebase-notification.service';
import { WebNotificationService } from './web-notification.service';
import { DeviceNotificationService } from './device-notification.service';

@NgModule({
    imports: [
        CommonModule,
        provideFirebaseApp((injector) => {
            const firebaseOptions = injector.get(FIREBASE_CONFIG);
            return initializeApp(firebaseOptions);
        }),
        provideMessaging(() => new Messaging({ app: getApp() }))
    ],
    declarations: [],
    providers: [WebNotificationService, DeviceNotificationService, FIREBASE_CONFIG_PROVIDER]
})
export class FirebaseModule {}
